module.exports = __webpack_public_path__ + "img/7.de1c3e41.jpg";